import { render, staticRenderFns } from "./BookingDetailsDatesModal.vue?vue&type=template&id=10618cc7"
import script from "./BookingDetailsDatesModal.vue?vue&type=script&lang=js"
export * from "./BookingDetailsDatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports